export declare namespace AdminConfigTableTokenSections {
	interface Header {
		fontSize: string;
		lineHeight: string;
		fontWeight: string;
	}

	interface CellText {
		fontSize: string;
		lineHeight: string;
	}

	interface CellError {
		fontSize: string;
		lineHeight: string;
	}
}

export type AdminConfigTableTokens = {
	header: AdminConfigTableTokenSections.Header;
	cellText: AdminConfigTableTokenSections.CellText;
	cellError: AdminConfigTableTokenSections.CellError;
};

export const header: AdminConfigTableTokenSections.Header = {
	fontSize: '{app.sm.font.size}',
	lineHeight: '{app.sm.line.height}',
	fontWeight: '500',
};

export const cellText: AdminConfigTableTokenSections.CellText = {
	fontSize: '{app.sm.font.size}',
	lineHeight: '{app.sm.line.height}',
};

export const cellError: AdminConfigTableTokenSections.CellError = {
	fontSize: '0.75rem',
	lineHeight: '1rem',
};

/** Typography of the admin configuration tables: column headers, plain cell text and a cell's error line. */
export default {
	header,
	cellText,
	cellError,
} satisfies AdminConfigTableTokens;
